import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';
import { ProfessionalSubCategory } from '../models/professional-sub-category';
import { ProfessionalSubCategoryDTO } from '../models/professional-sub-category-dto';
import { CountrySettings } from './Models/CountrySettings';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageConfigurationService {

  constructor(private service: PHBHPApiService) {
    //this.service.apiUrl ="http://localhost:7000/api/"
  }

  getDepartmentDetails() {
    return this.service.getApi('departments/GetDepartments', true);
  }
  getDepartmentList() {
    return this.service.getApi('Departments/GetDepartments', true);
  }
  getDepartmentTypeList() {
    return this.service.getApi('Departments/GetDepartmentTypes', true);
  }
  createWard(data) {
    return this.service.postApi('Wards/CreateWard', data, true);
  }
  updateWard(id,data) {
    return this.service.putApi('Wards/UpdateWard/' + id, data, true);
  }
  deleteWard(id) {
    return this.service.deleteApi('Wards/DeleteWard/' + id, true);
  }

  activeWard(id) {
    return this.service.postApi('Wards/ActiveWard/' + id, {}, true);
  }

  getInstitutionsbyId(id, roleId) {
    if(roleId != 3){
      return this.service.getApi('institutions/GetInstitutionsByIds/' + id, true);
    } else {
      return this.service.getApi('institutions/GetInstitutionByGroupId/' + id, true);
    }
  }
  getWardsbyInstitutionId(id) {
    return this.service.getApi('ManageInstitution/GetInstituionWards/'+ id, true);
  }
  getWardsAndDepartments(id) {
    return this.service.getApi('SOPEvaluation/GetWardsAndDepartments/'+ id, true);
  }
  getCountryList() {
    return this.service.getApi('countries', true);
  }
  getCountry(id) {
    return this.service.getApi('UserProfile/GetUsersByRoleId/' + id, true);
  }
  createCountry(data) {
    return this.service.postApi('UserProfile/AddUserOrSubscribe',data, true);
  }
  updateCountry(id, data) {
    return this.service.putApi('Users/UpdateUserDetails/' + id, data, true);
  }
  deleteCountry(id) {
    return this.service.deleteApi('Users/' + id, true);
  }

  createProfessionalCategory(data) {
    return this.service.postApi('ProfessionalCategories/CreateProfessionalCategory',data, true);
  }
  updateProfessionalCategory(id, data) {
    return this.service.putApi('ProfessionalCategories/UpdateProfessionalCategory/'+id, data,true);
  }
  deleteProfessionalCategory(id) {
    return this.service.deleteApi('ProfessionalCategories/deleteProfessionalCategory/'+id,true);
  }

  createSubCategory(subCategory: ProfessionalSubCategory) {
    return this.service.postApi('ProfessionalSubCategories/CreateProfessionalSubCategory',subCategory, true);
  }
  updateSubCategory(id, subCategory: ProfessionalSubCategoryDTO) {
    return this.service.putApi('ProfessionalSubCategories/UpdateProfessionalSubCategory/'+id, subCategory,true);
  }
  deleteSubCategory(id) {
    return this.service.deleteApi('ProfessionalSubCategories/DeleteProfessionalSubCategory/'+id,true);
  }
  createDepartment(data) {
    return this.service.postApi('Departments/CreateDepartment', data, true);
  }
  deleteDepartment(id) {
    return this.service.deleteApi('Departments/DeleteDepartment/' + id, true);
  }
  updateDepartment(id, data) {
    return this.service.putApi('Departments/UpdateDepartment/' + id, data, true);
  }
  getCountriesKeyValuePair() {
    return this.service.getApi("countries/GetCountriesKeyValuePair", true);
  }
  GetInstitutionDetails(id) {
    // tslint:disable-next-line:max-line-length
    return this.service.getApi(`ManageInstitution/GetInstituionDetails/` + id, true);
  }
  uploadImage(data) {
    return this.service.postFileApi('InstitutionImageUploader', data, true);
  }
  getImagesByInstitutionId(id) {
    return this.service.getApi('InstitutionImageUploader/' + id, true);
  }
  deleteImageById(id) {
    return this.service.deleteApi('InstitutionImageUploader/DeleteImageLibrary/' + id, true);
  }
  updateImageById(id, data) {
    return this.service.putFileApi('InstitutionImageUploader/UpdateFile/' + id, data, true);
  }
  createImage(data) {
    return this.service.postFileApi('ImageUploader', data, true);
  }
  getImage() {
    return this.service.getApi('ImageUploader', true);
  }
  getImageById(userId, roleId, countryId) {
    return this.service.getApi(`ImageUploader/GetImagesByUserId/${userId}/${roleId}/${countryId}`, true);
  }
  deleteImage(id) {
    return this.service.deleteApi('ImageUploader/' + id, true);
  }
  updateImage(id, data) {
    return this.service.putFileApi('ImageUploader/UpdateFile/' + id, data, true);
  }
  createTutorial(data) {
    return this.service.postFileApi('TutorialsUploader', data, true);
  }
  getTutorials() {
    return this.service.getApi('Tutorials/GetTutorials', true);
  }
  deleteTutorial(id) {
    return this.service.deleteApi('TutorialsUploader/' + id, true);
  }
  updateTutorial(id, data) {
    return this.service.putFileApi('TutorialsUploader/' + id, data, true);
  }
  getTutorialsByTutorialId(id) {
    return this.service.getApi('Tutorials/GetTutorialById/' + id, true);
  }
  createConfigDetails(data) {
    return this.service.postApi('ConfigureGeneral/CreateGeneralConfiguration',data, true);
  }
  updateConfigDetails(id,data) {
    return this.service.putApi(`ConfigureGeneral/UpdateGeneralConfiguration/${id}`,data, true);
  }
  updateConsumptionConfig(id, data){
    return this.service.putApi(`ConfigureGeneral/UpdateConsumptionConfiguration/${id}`,data, true);
  }
  getConfigDetails(id){
    return this.service.getApi('ObserveObservation/GetGeneralConfigurationByInstitutionId/' + id, true);
  }
  getQuotasByInstitutionId(id){
    return this.service.getApi('ObserveObservation/GetQuotasByInstitutionId/' + id, true);
  }
  createQuota(data){
    return this.service.postApi('Quota/CreateQuota', data, true);
  }
  getQuotaDetail(quotaId, institutionId){
    return this.service.getApi(`Quota/GetQuotaDetail/${quotaId}/${institutionId}`, true);
  }
  updateQuota(id, data){
    return this.service.putApi(`Quota/UpdateQuota/${id}`,data, true);
  }
  deleteQuota(id) {
    return this.service.deleteApi('Quota/DeleteQuota/' + id, true);
  }
  createComments(data) {
    return this.service.postApi('observations/CreatePredefinedComment', data, true);
  }
  getCommentsbyInstitutionId(countryid,roleid,institutionid) {
    return this.service.getApi('observations/GetPredefinedCommentsList/' + countryid + '/' + roleid+ '/' + institutionid , true);
  }
  updateComments(id, data) {
    return this.service.putApi('observations/UpdatePredefinedComment/'+ id, data, true);
  }
  deleteComment(predefinedCommentID,userId){
    return this.service.deleteApi('observations/DeletePredefinedComment/' + predefinedCommentID + '/' + userId , true);
  }
  updateNoSterilityDetails(institutionId,isNoSterility){
   return this.service.putApi(`Institutions/UpdateInstitutionNoSterility/${institutionId}/${isNoSterility}`,undefined,true);
  }
  getWebKessWardsByInsId(id) {
    return this.service.getApi('CHCIntegration/GetWebKessWardsByInstution/'+ id, true);
  }

  getInsWebKessStations(insId) {
    return this.service.getApi('ManageInstitution/GetInstituionWebKessStations/'+ insId, true);
  }

  getwebKessInstitutionDetails(insId) {
    return this.service.getApi('ManageInstitution/GetwebKessInstituionDetails/'+ insId, true);
  }

  getwebKessPeriodsDetail(insId) {
    return this.service.getApi('ManageInstitution/GetwebKessPeriodsDetail/'+ insId, true);
  }
  
  webKessIntervalsObservations(postData) {
    return this.service.postApi('CHCIntegration/WebKessIntervelsObservations', postData, true);
  }

  webKessIntervalsDeletion(postData)
  {
    return this.service.postApi('CHCIntegration/WebKessIntervelsDeletion', postData, true);
  }

  GetInstituionWebKessRecentExportDetail(insId) {
    return this.service.getApi('ManageInstitution/GetInstituionWebKessRecentExportDetail/'+ insId, true);
  }

  importwebKessWards(id, postData) {
    return this.service.postApi('ManageInstitution/ImportwebKessWards/'+ id, postData,true);
  }
  updatewebKessWards(userId, postData, mapMode) {
    return this.service.postApi('Wards/UpdatewebKessWards/'+ userId, postData,true);
  }

  getDefaultCountrySettings(countryId: number) {
    return this.service.getApi(`Institutions/GetNewInstitutionDefaultSettingsByCountry/${countryId}`, true)
  }

  saveDefaultCountrySettings(countryId: number, settings: CountrySettings) {
    return this.service.postApi(`Institutions/SaveNewInstitutionDefaultSettingsByCountry/${countryId}`, settings, true)
  }
  
  getUsersInstitutions(userId, roleId) {
    return this.service.getApi(`ManageInstitution/GetUsersInstitutions/${userId}/${roleId}`, true);
  }
  updateCountryCompliance(data) {
    return this.service.postApi('ObserveObservation/UpdateCountryCompliance', data, true)
  }
  updateInstitutionCompliance(data) {
    return this.service.postApi('ObserveObservation/UpdateInstitutionCompliance', data, true)
  }
  getInstitutionIdsById(id) {
    return this.service.getApi(`Institutions/GetInstitutionIdsById/${id}`, true)
  }
  getPredefinedCommentsListForIA(countryId, institutionGroupIds, institutionId){
    return this.service.getApi(`Observations/GetPredefinedCommentsListForIA/${countryId}/${institutionGroupIds}/${institutionId}`, true);
  }
  getDisabledPredefinedCommentsByIA(institutionId) {
    return this.service.getApi(`Observations/GetDisabledPredefinedCommentsByIA/${institutionId}`, true)
  }
  updateCommentsAsIA(id, data) {
    return this.service.putApi('observations/UpdatePredefinedCommentAsIA/'+ id, data, true);
  }
}